import styled, {keyframes} from 'styled-components';
import {DefaultTheme} from 'styled-components';
import {Color} from '../../../../../../common/utils/color-util';
import {PlayRealButtonDefaultBox} from './play-real-button.default.box';

const PulseAnimation = (props: {theme: DefaultTheme}) => keyframes`
    0% {
        box-shadow: 0 0 0 0 ${Color.fromHex(props.theme.colors.brandPrimary, 0.8).rgba()};
    }
    80% {
        box-shadow: 0 0 0 20px ${Color.fromHex(props.theme.colors.brandPrimary, 0).rgba()};
    }
    100% {
        box-shadow: 0 0 0 0 ${Color.fromHex(props.theme.colors.brandPrimary, 0).rgba()};
    }
`;

export const PlayRealButtonCasino888Box = styled(PlayRealButtonDefaultBox)`
    background-position: -553px -409px;
    width: 5rem;
    height: 5rem;
    border-radius: 50%;
    box-shadow: 0 0 0 0 ${(props) => Color.fromHex(props.theme.colors.brandPrimary, 0.5).rgba()};

    @media ${({theme}) => theme.mediaQuery.lowHeight}, ${({theme}) => theme.mediaQuery.xlExact} {
        width: 6rem;
        height: 6rem;
    }
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        width: 5rem;
        height: 5rem;
        background-position: -553px -409px;
    }

    /** For the moment for 888 skin we display it always (with opacity 0, we show it at click) */
    display: block;

    &:active, &.play-game-button-active {
        animation: ${PulseAnimation} 1s;
        transform: translateY(0);
        opacity: 0.9;
    }
`;